import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import LoginPage from './views/LoginPage';
import TutorDashboard from './views/TutorDashboard';
import AdminDashboard from './views/AdminDashboard';
import PrivateRoute from './components/PrivateRoute';
import TimezoneNotice from './components/TimezoneNotice';
import LegacyLinkRedirect from './components/LegacyLinkRedirect';
import './assets/App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <TimezoneNotice />
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route 
            path="/tutor/*" 
            element={
              <PrivateRoute requiredRole="tutor">
                <TutorDashboard />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/admin/*" 
            element={
              <PrivateRoute requiredRole="admin">
                <AdminDashboard />
              </PrivateRoute>
            } 
          />
          {/* Catch-all for legacy / mistyped top-level paths (e.g. old
              notification links like /claims/:id) so they redirect to a real
              route instead of rendering a blank white page. */}
          <Route path="*" element={<LegacyLinkRedirect />} />
        </Routes>
      </div>
      <Analytics />
    </Router>
  );
}

export default App;